import { createContext, useContext } from 'react'

/** Повертає true, якщо закривати drawer зараз не можна без підтвердження (є незбережені зміни) */
export type DirtyGuard = () => boolean

export interface DrawerGuardApi {
    setGuard: (guard: DirtyGuard | null) => void
}

/**
 * Зв'язок між AppDrawer і вмістом: вміст (DetailShell) реєструє перевірку незбережених
 * змін, drawer питає її перед закриттям.
 */
export const DrawerGuardContext = createContext<DrawerGuardApi | null>(null)

export const useDrawerGuard = (): DrawerGuardApi | null => useContext(DrawerGuardContext)
